import { Box, BoxProps, styled } from "@mui/material";

export const Container = styled(Box, {
  shouldForwardProp: (prop: string) => !prop.includes("$"),
})<BoxProps & { $type?: string }>(({ theme, $type = 'top' }) => ({
  position: "relative",
  overflow: "hidden",
  borderRadius: '15px',
  ...($type === 'top' && ({
    padding: '1px 1px 0 1px',
    backgroundImage: 'linear-gradient(180deg, #E2D8CE 0%, #1D1C1B 104%)',
  })),
  ...($type === 'bottom' && ({
    padding: '0 1px 1px 1px',
    backgroundImage: 'linear-gradient(180deg, #1D1C1B 0%, #E2D8CE 104%)',
  })),
}));